<img [src]="image.url" >
